import { AxiosResponse } from 'axios';
import { apiUrl, post, get, put } from 'utils/apiMgmt';

export const changePassword = async (params: { currentPassword: string; password: string }) => {
  return await put(`${apiUrl}/auth/change-password`, params);
};
